import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as R from 'ramda';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { IQueryPuids } from '../../../../common/repositories/dailyrent/entities/query_puids/QueryPuids';
import { selectPuids } from '../../../../common/selectors/listingOffers';
import { EListingBannerType } from '../../../constants/banner';
import { AdfoxBanner } from '../AdfoxBanner';
import { AdfoxDeviceTypeContext } from '../AdfoxBanner/adfoxDeviceTypeContext';
import { useListingBanner } from '../useListingBanner';

const BANNER_HEIGHT = 366;

const P_PARAMS = { p1: 'bvkoa', p2: 'y' };

interface IParallaxListingBannerProps {
  position?: number;
}

export const ParallaxListingBanner: React.FC<IParallaxListingBannerProps> = ({ position }) => {
  const { isHidden, onClick, onError, onView, onLoad, onStub } = useListingBanner({
    bannerType: EListingBannerType.Parallax,
    position,
  });

  const puids = useSelector(selectPuids);
  const sourcePuids: Partial<IQueryPuids> = puids ?? {};
  const filteredPuids = R.pickBy(Boolean, sourcePuids) as Partial<IQueryPuids>;
  const commonPuids = Object.keys(filteredPuids).reduce<{ [key: string]: string }>((acc, puidKey) => {
    acc[puidKey] = String(filteredPuids[puidKey as keyof IQueryPuids]);

    return acc;
  }, {});

  if (isHidden) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={onView} percentVisible={0.5} triggerOnce>
      <div onClick={onClick}>
        <AdfoxDeviceTypeContext.Provider value="phone">
          <AdfoxBanner
            ownerId={202100}
            params={{ ...commonPuids, ...P_PARAMS }}
            width="100%"
            height={BANNER_HEIGHT}
            lazyLoad={{ fetchMargin: 100, mobileScaling: 1 }}
            onLoad={onLoad}
            onStub={onStub}
            onError={onError}
          />
        </AdfoxDeviceTypeContext.Provider>
      </div>
    </ActionAfterViewObserver>
  );
};

ParallaxListingBanner.displayName = 'ParallaxListingBanner';
